import { render } from "./PagoExitoso.vue?vue&type=template&id=b6b08d1c&scoped=true"
import script from "./PagoExitoso.vue?vue&type=script&lang=js"
export * from "./PagoExitoso.vue?vue&type=script&lang=js"

import "./PagoExitoso.vue?vue&type=style&index=0&id=b6b08d1c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6b08d1c"]])

export default __exports__